// redux
import store from '../../redux/store';

const canEditDealershipNamePermission = (
  {is_superuser = false} = store.getState().authorization.userData
) => is_superuser;

export default canEditDealershipNamePermission;
